import React from 'react'
import PageContainer from './PageContainer/PageContainer'
import scrollToFirstError from 'utils/formUtils'

import { handleError } from 'utils/apiErrorHandler'
import {
  BaseComponent,
  Loader
} from 'belle-js'

import styles from './FormStyles.module.scss'

const withOnboardingSection = (FormComponent) => {
  class OnboardingSection extends BaseComponent {

    constructor (props) {
      super(props)
      const {
        description,
      } = props

      this.state = {
        isLoadingPage: false,
        description
      }
      this.bind('onSuccess', 'onFailure', 'submitForm', 'handleOnClick')
    }

    handleOnClick () {
      scrollToFirstError()
    }

    onSuccess (result) {
      const { setData, editFinancialAccount, goNextSection } = this.props
      const { responseData, financialAccount } = result

      setData(responseData)

      if (financialAccount) {
        editFinancialAccount(financialAccount)
      }

      if (goNextSection) {
        goNextSection()
      }
    }

    onFailure (error) {
      handleError(error)
    }

    async submitForm (formData) {
      const {
        mapValues,
        submitAction,
        updateAccount,
      } = this.props

      const result = {}

      this.setState({ isLoadingPage: true })
      let finalData = formData
      if (mapValues) {
        finalData = mapValues(formData)
      }

      result.responseData = await submitAction(finalData)

      if (updateAccount) {
        result.financialAccount = await updateAccount()
      }

      this.setState({ isLoadingPage: false })

      return result
    }

    render () {
      const {
        hide,
        isMobile,
        formName,
        data,
        isLoading,
        upperTitle,
        currentSelectedTab,
        onChangeSelectedTab,
        description,
        formType,
        pageContainerClassName,
        prevPageInfo,
        contacts,
      } = this.props

      const {
        isLoadingPage,
      } = this.state
      return (
        <PageContainer
          description={description}
          name={formName}
          upperTitle={upperTitle}
          hide={hide || isLoading}
          isMobile={isMobile}
          isLoading={isLoading}
          className={pageContainerClassName}
          prevPageInfo={prevPageInfo} >

          {isLoadingPage && <Loader className={styles.PWMLoader} />}

          <FormComponent
            {...this.props}
            initialData={data ? data : {}}
            isMobile={isMobile}
            submitForm={this.submitForm}
            successHandler={this.onSuccess}
            failureHandler={this.onFailure}
            currentSelectedTab={currentSelectedTab}
            onChangeSelectedTab={onChangeSelectedTab}
            contacts={contacts}
            onClick={this.handleOnClick}
            formType={formType} />

        </PageContainer>
      )
    }

  }

  return OnboardingSection
}

export default withOnboardingSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/withOnboardingSection.jsx